var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8543",
    "data-name": "Grupo 8543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8092-2",
    "data-name": "Grupo 8092-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_849",
    "data-name": "Elipse 849"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42,
    cy: 42.5,
    rx: 42,
    ry: 42.5,
    style: {
      fill: "#f6f5fb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42,
    cy: 42.5,
    rx: 41,
    ry: 41.5,
    style: {
      fill: "none",
      stroke: "#ce5496",
      strokeWidth: 2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8545",
    "data-name": "Grupo 8545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2714",
    "data-name": "Trazado 2714",
    d: "M47,58.63c-12.25,0-22.4-11.73-22.4-13.82S34.75,31,47,31,69.4,43.32,69.4,44.81C69.4,46.83,59,58.63,47,58.63Z",
    style: {
      fill: "#f5cae1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Componente_1",
    "data-name": "Componente 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    x: 14,
    y: 17,
    width: 56,
    height: 56,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3420",
    "data-name": "Grupo 3420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3418",
    "data-name": "Grupo 3418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2714-2",
    "data-name": "Trazado 2714-2",
    d: "M42,58.63c-12.25,0-22.4-11.73-22.4-13.82S29.75,31,42,31,64.4,43.32,64.4,44.81C64.4,46.83,54,58.63,42,58.63ZM21.09,44.81C21.54,46.6,30.73,57.13,42,57.13S62.09,46.6,62.91,44.81C62,43,53,32.49,42,32.49S21.62,43,21.09,44.81Z",
    style: {
      fill: "#ce5496"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3419",
    "data-name": "Grupo 3419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2715",
    "data-name": "Trazado 2715",
    d: "M42,54.33a9.48,9.48,0,0,1-9.51-9.46v-.06a8.87,8.87,0,0,1,.51-3,9.48,9.48,0,0,1,18,0,9.13,9.13,0,0,1,.52,3,9.51,9.51,0,0,1-9.47,9.52ZM42,37a7.74,7.74,0,0,0-7.35,5.27,8,8,0,0,0-.44,2.51,7.79,7.79,0,0,0,15.58,0,7.44,7.44,0,0,0-.44-2.42A7.69,7.69,0,0,0,42,37Z",
    style: {
      fill: "#ce5496"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.4dc9f1d4.svg";
export { ForwardRef as ReactComponent };